module.exports = __webpack_public_path__ + "img/NW13.66133cce.jpg";